import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { formatTime } from './lib/utils'
import { createMetaArray, isChaptersMode } from 'utils/functions'
import ReactList from 'react-list'
import css from './MetaList.module.sass'
import cx from 'classnames'
import { Icon, Dimmer, Dropdown, Input } from 'semantic-ui-react'
import MetaReplacer from 'components/MetaReplacer/MetaReplacer'

class MetaList extends Component {
  constructor () {
    super(...arguments)

    this.state = {
      listHeight: this.calcListHeight(this.props.playerElement),
      filterType: isChaptersMode() ? 2 : 1,
      operator: 1,
      filterValue: isChaptersMode() ? 'chapter' : '',
      activeIndex: null
    }

    this.meta = []
    this.itemHeight = 40
    this.filterOptions = [{
      text: 'dts',
      value: 1
    }, {
      text: 'action',
      value: 2
    }]
    this.operatorsList = [{
      key: 1,
      text: '=',
      value: 1
    }, {
      key: 2,
      text: '>',
      value: 2
    }, {
      key: 3,
      text: '<',
      value: 3
    }]

    this.handleWindowResize = this.handleWindowResize.bind(this)
    this.onSelectMetaItem = this.onSelectMetaItem.bind(this)
    this.onRemoveMetaItem = this.onRemoveMetaItem.bind(this)
    this.onRenderMetaItem = this.onRenderMetaItem.bind(this)
    this.onMoveToTiming = this.onMoveToTiming.bind(this)

    window.addEventListener('resize', this.handleWindowResize)
  }

  componentWillUpdate (nextProps) {
    if (this.props.playerElement !== nextProps.playerElement) {
      this.setState({ listHeight: this.calcListHeight(nextProps.playerElement) })
    }
  }

  componentWillReceiveProps (nextProps) {
    // if (this.props.activeItem && this.props.activeItem !== nextProps.activeItem) {
    //   this.setActiveIndex()
    // }
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.handleWindowResize)
  }

  handleWindowResize () {
    this.setState({ listHeight: this.calcListHeight(this.props.playerElement) })
  }

  onSelectMetaItem (activeItem) {
    if (this.props.activeItem !== activeItem) {
      this.props.setActiveItem({ activeItem })
    }
  }

  onRemoveMetaItem (metaItem) {
    const isDelete = confirm('Вы точно хотите удалить это событие ?')

    if (isDelete) this.props.removeItem({ id: metaItem.id })
  }

  onMoveToTiming (dts) {
    this.props.playerElement.currentTime = dts / 1000
  }

  calcListHeight (player) {
    return (player && player.clientHeight - 100) || 0
  }

  // setActiveIndex () {
  //   let activeIndex
  //   createMetaArray(this.props.data).map((item, index) => {
  //     if (item.id === this.props.activeItem.id) {
  //       activeIndex = index
  //     }
  //   })
  //   this.setState({ activeIndex })
  // }

  onRenderMetaItem (index, key) {
    const { activeItem } = this.props
    const metaItem = this.meta[index]
    const metaItemTime = formatTime(new Date(metaItem.dts))
    const isSelectedItem = activeItem && activeItem.id === metaItem.id

    return (
      <div
        className={cx(css.item, isSelectedItem && css.active)}
        key={key}
        onClick={() => this.onSelectMetaItem(metaItem)}
      >
        {`<${metaItemTime}>`}
        <b>{ metaItem.meta.action && ` ${metaItem.meta.action}` }</b>
        { isSelectedItem &&
          <div className={css.controls}>
            <Icon
              name='eye'
              title='Показать тайминг в видео'
              onClick={() => this.onMoveToTiming(metaItem.dts)}
            />
            <Icon
              name='remove circle'
              title='Удалить событие'
              onClick={() => this.onRemoveMetaItem(metaItem)}
            />
          </div>
        }
      </div>
    )
  }

  render () {
    const { data, updateMeta } = this.props
    const { filterType, filterValue, operator, listHeight } = this.state

    this.meta = createMetaArray(data)

    if (!this.meta.length) return null
    if (filterValue) {
      this.meta = this.meta.filter(item => {
        if (filterType === 1) {
          if (operator === 1) return item.dts === filterValue
          if (operator === 2) return item.dts > filterValue
          if (operator === 3) return item.dts < filterValue
        } else {
          return item.meta && item.meta.action && item.meta.action.indexOf(filterValue) !== -1
        }
      })
    }

    return (
      <div className={css.list}>
        <Dimmer.Dimmable dimmed={isChaptersMode()}>
          <Dimmer active={isChaptersMode()} inverted />
          <div className={css.filter}>
            <Dropdown
              inline
              icon='filter'
              size='mini'
              value={filterType}
            >
              <Dropdown.Menu>
                {
                  this.filterOptions.map(option => <Dropdown.Item
                    key={option.value}
                    {...option}
                    onClick={(e, data) => this.setState({ filterType: data.value, operator: 1, filterValue: '' })}
                  />)
                }
              </Dropdown.Menu>
            </Dropdown>
            <strong className={css.typeName}>
              {this.filterOptions.filter(item => item.value === filterType)[0].text}
            </strong>
            <Dropdown
              inline
              options={this.operatorsList}
              size='mini'
              value={operator}
              onChange={(e, data) => this.setState({ operator: data.value })}
              disabled={filterType === 2}
            />
            <Input
              className={css.search}
              icon='search'
              size='mini'
              value={filterValue}
              onChange={(e, data) => this.setState({ filterValue: data.value })}
            />
            <div className={css.replace}>
              <MetaReplacer meta={createMetaArray(data)} updateMeta={updateMeta} />
            </div>
          </div>
        </Dimmer.Dimmable>
        { this.meta.length > 0 &&
          <div style={{ 'overflow': 'auto', 'height': listHeight }}>
            <ReactList
              ref={(list) => { this.metaList = list }}
              itemRenderer={this.onRenderMetaItem}
              length={this.meta.length}
              type='uniform'
            />
          </div>
        }
      </div>
    )
  }
}

const {
  object,
  func
} = PropTypes

MetaList.propTypes = {
  data: object.isRequired,
  activeItem: object,
  playerElement: object,
  setActiveItem: func.isRequired,
  removeItem: func.isRequired,
  updateMeta: func.isRequired
}

export default MetaList



// WEBPACK FOOTER //
// ./src/components/MetaList/MetaList.js